import React, { useContext } from 'react';
import { LiveTrainStatusContext } from '../LiveTrainStatus';
import { getDateObjectFromDetails, getRemainingTimeInHoursAndMinutes } from '../utils/commonLtsUtils';

export function CurrentAndNextStationDetails() {
  const { ltsPageState } = useContext(LiveTrainStatusContext);
  const { currentStation, nextStation } = { ...ltsPageState };
  if (!currentStation || !nextStation) {
    return null;
  }
  const {
    stationName: currentStationName,
    actualDepartureDetails: { actualDepartureTime: currentStationActualDepartureTime },
    platformNumber: currentStationPlatformNumber
  } = currentStation;
  const {
    stationName: nextStationName,
    actualArrivalDetails: {
      actualArrivalTime: nextStationActualArrivalTime,
      actualArrivalDate: nextStationActualArrivalDate
    },
    platformNumber: nextStationPlatformNumber
  } = nextStation;
  const remainingTimeForArrival = getRemainingTimeInHoursAndMinutes(
    getDateObjectFromDetails({
      dateInString: nextStationActualArrivalDate,
      timeInString: nextStationActualArrivalTime
    }),
    new Date(),
    'h'
  );
  return (
    <React.Fragment>
      {currentStation && nextStation && (
        <div className="liveTrainBetweenTwoStations__destDetails">
          <div className="makeFlex column flexOne ">
            <span className="font14 lightGreyText appendBottom6">Last Station</span>
            <span className="font16 latoBold appendBottom6 blackText">{currentStationName}</span>
            <div className="makeFlex appendBottom5">
              <span>
                Crossed at <span className="latoBold blackText">{currentStationActualDepartureTime}</span>
              </span>
            </div>
            <span>
              {!!currentStationPlatformNumber && currentStationPlatformNumber !== '0'
                ? `PL #${currentStationPlatformNumber}`
                : 'PL --'}
            </span>
          </div>
          <div className="makeFlex column bottom flexOne right">
            <span className="font14 lightGreyText appendBottom6">Next Station</span>
            <span className="font16 latoBold appendBottom6 blackText textRight">{nextStationName}</span>
            <div className="makeFlex textRight">
              <span>Exp Arr. &nbsp;</span>
              <span className="appendBottom5 greenText latoBlack">{nextStationActualArrivalTime}</span>
            </div>
            <div className={'textRight'}>
              <span>
                Time left <span className="yellowText latoBlack">{remainingTimeForArrival}</span>
              </span>
              <br />
              <span className={'textRight'}>
                {!!nextStationPlatformNumber && nextStationPlatformNumber !== '0'
                  ? `PL #${nextStationPlatformNumber}`
                  : 'PL --'}
              </span>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default CurrentAndNextStationDetails;
